import { clsx } from "clsx"

type ButtonProps = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  variant?:
    | "primary"
    | "secondary"
    | "danger"
    | "transparent"
    | "primary-brand"
    | "outline-brand";
  size?: "full" | "fit";
};

export const Button = ({
  variant = "primary",
  className,
  size = "full",
  ...props
}: ButtonProps) => {
  return (
    <button
      {...props}
      className={clsx(
        "cursor-pointer disabled:cursor-default",
        "button-hover",
        "inline-flex items-center justify-center gap-2 px-4 py-2",
        "rounded-full shadow-none appearance-none border",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        "text-base font-medium",
        size === "full" && "w-full",
        size === "fit" && "w-fit",
        {
          "bg-zinc-800 text-white hover:bg-zinc-700 active:bg-zinc-600 border-transparent":
            variant === "primary",
          "bg-white text-zinc-900 hover:bg-zinc-100 active:bg-zinc-200 border-zinc-900":
            variant === "secondary",
          "bg-rose-500 text-white hover:bg-rose-600 active:bg-rose-900 border-transparent":
            variant === "danger",
          "bg-transparent text-zinc-900 hover:bg-transparent active:bg-transparent border-transparent":
            variant === "transparent",
          "bg-espresso text-cream hover:bg-espresso-dark active:bg-espresso-dark border-transparent":
            variant === "primary-brand",
          "bg-transparent text-espresso hover:bg-espresso hover:text-cream active:bg-espresso/90 border-espresso/30":
            variant === "outline-brand",
        },
        className
      )}
    />
  )
}
